import { lazy } from 'react';
// ----------------------------------------------------------------------

const ReportsPage = lazy(() => import('../pages/Reports.page'));
const Patient = lazy(() => import('../pages/patient/Patient'));
const BranchesAndEmployees = lazy(() => import('../pages/branches-and-employees/BranchesAndEmployees'));
const Marketing = lazy(() => import('../pages/marketing/Marketing'));
const Checkup = lazy(() => import('../pages/checkup/Checkup'));

// ----------------------------------------------------------------------

const ReportsRoutes = [
    {
        path: '/reports',
        element: <ReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/patient',
        element: <Patient />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/checkup',
        element: <Checkup />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/branches-and-employees',
        element: <BranchesAndEmployees />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/marketing',
        element: <Marketing />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ReportsRoutes };
